import { useOpenDialog } from '@/domain/hooks/useDialog'
import { useUnifiedPortfolio } from '@/features/portfolio'
import { withSuspense } from '@/ui/utils/withSuspense'

import { MyPortfolioSkeleton } from './components/skeleton/MyPortfolioSkeleton'
import { GuestView } from '@/ui/organisms/guest-view/GuestView'
import { PositionView } from './views/PositionView'
import { usePrivy } from '@privy-io/react-auth'
import { useAccount } from 'wagmi'

function MyPortfolioContainer() {
  const { address } = useAccount()
  const portfolio = useUnifiedPortfolio()
  const {
    allDeposits: deposits,
    allBorrows: borrows,
    positionSummary,
    netApyDetails,
    walletComposition,
    eModeCategoryId,
    liquidationDetails,
  } = portfolio.positionData.pooled
  const { connectWallet } = usePrivy()
  const openDialog = useOpenDialog()

  if (!address) {
    return <GuestView openConnectModal={connectWallet} />
  }

  if (
    portfolio.loading.pooledMarket ||
    portfolio.loading.evmWallet ||
    !positionSummary ||
    !netApyDetails ||
    !walletComposition
  ) {
    return <MyPortfolioSkeleton />
  }

  return (
    <PositionView
      positionSummary={positionSummary}
      deposits={deposits}
      borrows={borrows}
      walletComposition={walletComposition}
      eModeCategoryId={eModeCategoryId}
      openDialog={openDialog}
      liquidationDetails={liquidationDetails}
      netApyDetails={netApyDetails}
    />
  )
}

const MyPortfolioContainerWithSuspense = withSuspense(MyPortfolioContainer, MyPortfolioSkeleton)
export { MyPortfolioContainerWithSuspense as MyPortfolioContainer }
